module.exports = "\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/bigbools/bigbools.component.html
// module id = 465
// module chunks = 2